// c:\Projects\app-frontend\src\helpers\userPermission.js

const UserPermissions = {
  install(Vue, options) {
    Vue.prototype.$userPermissions = {
      permitted(slug) {
        return (
          options.store.getters["user/valid"] &&
          options.store.getters["user/isPermitted"](slug)
        );
      },
      role() {
        return options.store.getters["user/user"].role_id ?? null;
      },
    };
  },
};

export default UserPermissions;
